import { AdvancedImage } from "@cloudinary/react";
import { fill } from "@cloudinary/url-gen/actions/resize";
import { useToastContext } from "../../../../contexts/ToastContext/ToastContext";
import useConfirmSearch from "../../../../hooks/useConfirmSearch";
import localeText from "../../../../locale";
import { cloudinaryInstance } from "../../../../utilities/Cloudinary/cloudinaryInstance";
import { PLATFORM_PRODUCT_FEE } from "../../../../utilities/constants";
import { formatPrice } from "../../../../utilities/formatPrice";
import "../../../Shop/Shop.css";
import PromoterCommissionBadge from "../../../../components/PromoterShare/PromoterCommissionBadge";
import "./ProductCard.css";

import { Button } from "primereact/button";
import useProduct from "../../hooks/useProduct";
import { MiniAddToCart } from "./MiniAddToCart/MiniAddToCart";
import { useEffect, useLayoutEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";

const ProductCard = ({ product }) => {
  const { showErrorToast } = useToastContext();
  const { confirmSearch } = useConfirmSearch({
    productId: product?.id,
    onError: (code) => showErrorToast({ code }),
  });
  const location = useLocation();

  const isFringeBenefitsPage = location?.pathname?.toLowerCase()?.includes("fringe");

  const {
    productInfo,
    loadingProductInfo,
    currentAttribute1Value,
    currentAttribute2Value,
    currentVariation,
    productQty,
  } = useProduct({ id: product?.id });

  const currencySymbols = {
    USD: "$",
    EUR: "€",
    BRL: "R$",
    GBP: "£",
    JPY: "¥",
    CNY: "¥",
    AUD: "AU$",
    CAD: "CA$",
    CHF: "CHF",
  };

  const containerRef = useRef(null);
  const [containerWidth, setContainerWidth] = useState(null);
  useLayoutEffect(() => {
    const handleResize = () => {
      if (containerRef.current) {
        setContainerWidth(containerRef.current.offsetWidth);
      }
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const discountPercentageCalculation = (normalPrice, promotionalPrice) => {
    const discountPercentage = ((normalPrice - promotionalPrice) / normalPrice) * 100;
    return discountPercentage.toFixed(0);
  };

  const currencySymbol = currencySymbols[product?.currency] || product?.currency;

  const cashback = product?.percentExtraCoin / 100;
  const cashbackValue =
    (product?.promotionalPriceUnique ? product?.promotionalPriceUnique : product?.priceUnique) *
    cashback;
  const promotionalNormalPrice = product?.promotionalPriceUnique
    ? product?.promotionalPriceUnique * PLATFORM_PRODUCT_FEE + product?.promotionalPriceUnique
    : null;

  const normalPrice = isFringeBenefitsPage
    ? product?.priceUnique
    : product?.priceUnique * PLATFORM_PRODUCT_FEE + product?.priceUnique;

  const freightType = product?.shippingOption;

  const freightText =
    freightType === "PICKUP"
      ? localeText("paidOrWithdrawn")
      : freightType === "FREESENDCLOUD"
      ? localeText("freeToItaly")
      : freightType === "FREE"
      ? `${localeText("freight")} ${localeText("free")}`
      : `${localeText("freight")} ${localeText("paid")}`;

  const freightTextColor =
    freightType === "FREESENDCLOUD"
      ? "text-green-500"
      : freightType === "FREE"
      ? "text-green-500"
      : "text-primary";

  if (!product) return null;
  return (
    <div
      key={`pdis${product.id}`}
      ref={containerRef}
      className="flex flex-column flex-wrap w-full relative surface-0  border-round-lg overflow-hidden gap-3 section-card"
    >
      <div
        onClick={() => confirmSearch()}
        title={product.title}
        className="text-sm font-medium overflow-hidden cursor-pointer"
        style={{
          color: "#344563",
          textOverflow: "ellipsis",
          maxWidth: "100%",
          whiteSpace: "normal",
          overflow: "hidden",
          display: "-webkit-box",
          WebkitLineClamp: 2,
          WebkitBoxOrient: "vertical",
          lineHeight: "1.25rem", // Example line height
          minHeight: "calc(1.25rem * 2)", // 2 lines height
        }}
      >
        {product?.title}
      </div>
      {/* {(product?.downloadable || product?.service) && (
        <div className="w-full col">{""}</div>
      )} */}
      <div
        className="flex justify-content-center cursor-pointer relative"
        onClick={() => confirmSearch()}
      >
        <AdvancedImage
          cldImg={cloudinaryInstance
            .image(product?.imageid1)
            .resize(fill().width(250).height(250))
            .format("webp")}
          className="productCardImg"
        />
        <div className="absolute" style={{ top: 6, left: 6 }}>
          <PromoterCommissionBadge product={product} />
        </div>
        <div className="absolute" style={{ top: -6, right: -6 }}>
          {promotionalNormalPrice && (
            <Button
              style={{
                backgroundColor: "#FFD233",
                color: "#18181B",
                width: "40px",
                height: "40px",
                boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.06)",
              }}
              className=" border-round border-circle border-none p-1 flex align-items-center justify-content-center"
            >
              <div className="flex flex-column">
                <div style={{ fontSize: "10px" }} className="font-semibold">
                  {discountPercentageCalculation(normalPrice, promotionalNormalPrice)}%
                </div>
                <div className="text-xs font-semibold">OFF</div>
              </div>
            </Button>
          )}
          {}
        </div>
      </div>
      <div
        onClick={() => confirmSearch()}
        className="cursor-pointer"
        style={{ minHeight: "48px", height: "48px" }}
      >
        <div className="flex align-items-center justify-content-between w-full mb-2">
          {promotionalNormalPrice && (
            <div className="font-medium text-sm line-through" style={{ color: "#7A869A" }}>
              {currencySymbol} {formatPrice(normalPrice)}
            </div>
          )}
          {cashback > 0 && (
            <div className="font-medium" style={{ color: "#059669", fontSize: "10px" }}>
              Cashback {currencySymbol} {formatPrice(cashbackValue)}
            </div>
          )}
        </div>
        {promotionalNormalPrice && (
          <div className="font-bold title text-2xl" style={{ color: "#18181B" }}>
            {currencySymbol} {formatPrice(promotionalNormalPrice)}
          </div>
        )}
        {!promotionalNormalPrice && (
          <div className="font-bold title text-2xl" style={{ color: "#18181B" }}>
            {currencySymbol} {formatPrice(normalPrice)}
          </div>
        )}
      </div>
      <div className="flex flex-column mt-auto">
        {!loadingProductInfo && (
          <div className="">
            <MiniAddToCart
              containerWidth={containerWidth}
              productInfo={productInfo}
              currentVariation={currentVariation}
              currentAttribute1Value={currentAttribute1Value}
              currentAttribute2Value={currentAttribute2Value}
              productQty={productQty}
            />
          </div>
        )}

        {!isFringeBenefitsPage && !product?.downloadable && !product?.service && (
          <div
            className="flex align-items-end"
            style={{ minHeight: "2rem", height: "2rem", color: "#245AE5" }}
          >
            {product.sendBy === "SELLER" ? (
              <>
                {!product?.downloadable && !product?.service && (
                  <div className={`lg:text-sm text-xs flex align-items-start gap-1 `}>
                    <i className={`pi pi-truck `} /> {`${freightText}`}
                  </div>
                )}
              </>
            ) : (
              <>
                {!product?.downloadable && !product?.service && (
                  <div className={`lg:text-sm text-xs flex align-items-start gap-1 `}>
                    <i className={`pi pi-truck `} /> {`${freightText}`}
                  </div>
                )}
              </>
            )}
          </div>
        )}
      </div>
      {(product?.downloadable || product?.service) && <div className="w-full col">{""}</div>}
    </div>
  );
};

export default ProductCard;
